import React, { useEffect } from "react";
import {
  Box,
  CircularProgress,
  Typography,
  TypographyProps,
} from "@mui/material";
import { useInvitation } from "@helpers/queries/invitations";
import { toast } from "react-toastify";

type Props = TypographyProps & {
  inviteToken: string;
};

export const InvitedText = ({
  inviteToken,
  ...props
}: Props): React.ReactElement => {
  const {
    data: invitation,
    isLoading,
    error,
  } = useInvitation({ token: inviteToken });

  useEffect(() => {
    if (error) {
      toast.error(error.statusText ?? "An error happened");
    }
  }, [error]);

  if (error) {
    return <></>;
  }

  if (isLoading) {
    return (
      <Box paddingX={2}>
        <CircularProgress size={20} />
      </Box>
    );
  }

  return (
    <Typography
      fontSize={[24, 28, 32]}
      lineHeight={1.2}
      maxWidth={505}
      color="color.blue.dark"
      {...props}
    >
      You&apos;ve been invited to join the fine company of{" "}
      <Typography component="span" fontSize="inherit" fontWeight={700}>
        {invitation?.company?.name ?? ""}
      </Typography>
    </Typography>
  );
};
